import {IconProps} from 'react-toastify'
import ErrorWarningFillIcon from 'remixicon-react/ErrorWarningFillIcon'
import CheckboxCircleFillIcon from 'remixicon-react/CheckboxCircleFillIcon'

import {styledTheme} from '@festi/common/themes'

export default function ToastIcons({type}: IconProps) {
  switch (type) {
    case 'error':
      return <ErrorWarningFillIcon color={styledTheme.palette.error} />
    case 'success':
      return <CheckboxCircleFillIcon color={styledTheme.palette.success} />
    case 'warning':
      return <ErrorWarningFillIcon color={styledTheme.palette.warning} />
    default:
      return <></>
  }
}
